import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { UsageHistoryElement, UsageHistoryResponse, UsageHistoryResponseSchema } from '@api/models/dashboard';
import { environment } from '@environments/environment';
import { from, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsageData extends ApiServiceBase<UsageHistoryElement> {
  constructor() {
    super('stores', 'evoqAdmin');
  }

  fetchUsageHistory(storeId: string, period: { year: number; month: number }): Observable<UsageHistoryResponse> {
    if (environment.isMockEnabled) {
      return from(import('@mock/schema/dashboard/list.usage-history.mock')).pipe(
        map((mock) => mock.listUsageHistoryMock())
      );
    }

    // Admin API: GET /api/v1/stores/{storeId}/usage?year=&month= returns the per-user/per-month
    // consumption for the requested month plus the 2 previous ones (rolling 3-month window).
    return this.customRequest<unknown>({
      method: 'GET',
      url: `${storeId}/usage`,
      query: { year: String(period.year), month: String(period.month) },
    }).pipe(
      map((response) => {
        const result = UsageHistoryResponseSchema.safeParse(response);
        if (!result.success) {
          throw new Error('Invalid usage history response');
        }
        return result.data;
      })
    );
  }
}
